import { Entrance, Flat, FlatField, flatSchema, Gallery, Shaxmatka, Terrace, terraceSchema } from './schema';

export const generateShaxmatka = (entrances: Entrance[] = []): Shaxmatka.Main => {
  const shaxmatka: Shaxmatka.Main = {
    entrance: {},
    column: {},
    row: { count: entrances[0]?.floors, list: {} },
    flat: { ids: [], list: {} }
  };

  for (const { id, flats, flatsPerFloor, floors, orders } of entrances) {
    shaxmatka.row.count = floors >= shaxmatka.row.count ? floors : shaxmatka.row.count;

    shaxmatka.entrance[id] = [];

    const columnKEY = `column-${orders}-${id}`;

    shaxmatka.column[columnKEY] = { count: flatsPerFloor, list: {}, entranceId: id };

    for (const flat of flats) {
      flat.isNew = !Number.isInteger(flat.id);

      shaxmatka.entrance[id].push(flat.id);

      shaxmatka.row.list[flat.floor!] = shaxmatka.row.list[flat.floor!] || [];
      shaxmatka.row.list[flat.floor!].push(flat.id!);

      shaxmatka.column[columnKEY].list[flat.col!] = shaxmatka.column[columnKEY].list[flat.col!] || [];
      shaxmatka.column[columnKEY].list[flat.col!].push(flat.id!);

      shaxmatka.flat.ids.push(flat.id!);
      shaxmatka.flat.list[flat.id!] = flat;
    }
  }

  return shaxmatka;
};

const diffGallery = (galleries1: Gallery[] = [], galleries2: Gallery[] = []) => {
  const galleries: Gallery[] = [];

  if (!galleries1.length || !galleries2.length) return galleries;

  for (let idx = 0; idx < galleries1.length; idx++) {
    const currentGallery = galleries2?.[idx];
    const flatGallery = galleries1?.[idx];

    if (currentGallery?.fileId === flatGallery?.fileId) {
      delete flatGallery.id;
      galleries.push(flatGallery!);
    }
  }

  return galleries;
};

const diffTerrace = (terrace1: Terrace, terrace2: Terrace) => {
  if (!terrace1 || !terrace2) return null;

  const terrace: Terrace = terraceSchema.parse(terrace1);

  delete terrace.id;

  for (const key in terrace) {
    if (terrace[key as keyof Terrace] !== terrace2[key as keyof Terrace]) {
      return null;
    }
  }

  return terrace;
};

const diffFields = (fields1: FlatField[], fields2: FlatField[]) => {
  if (fields1?.length === 0 || fields2!.length === 0) return null;

  const compareField = fields2.reduce<Record<string, string | number>>((record, field) => {
    record[field.fieldId!] = field.value!;

    return record;
  }, {});

  const fields: FlatField[] = fields1.filter(field => compareField[field.fieldId] === field.value);

  return fields;
};

export const generateFlat = (flatIds: number[], flats: Record<number, Flat>): Flat | undefined => {
  const flat = flats[flatIds[0]] ? flatSchema.parse(flats[flatIds[0]]) : undefined;

  for (const flatId of flatIds) {
    const current = flatSchema.parse(flats[flatId]);

    for (const key in flat) {
      if (key === 'gallery' && flat.gallery?.length) {
        const galleries = diffGallery(flat?.gallery! || [], current?.gallery! || []);

        flat.gallery = galleries;

        // eslint-disable-next-line no-continue
        continue;
      }

      if (key === 'terrace' && flat?.terrace) {
        const terrace = diffTerrace(flat?.terrace!, current?.terrace!);

        if (terrace === null) {
          delete flat.terrace;
          // eslint-disable-next-line no-continue
          continue;
        }

        flat.terrace = terrace;

        // eslint-disable-next-line no-continue
        continue;
      }

      if (key === 'fields' && flat?.fields?.length) {
        const fields = diffFields(flat?.fields || [], current?.fields || []);

        flat.fields = fields;

        // eslint-disable-next-line no-continue
        continue;
      }

      if (current[key as keyof Flat] !== flat[key as keyof Flat]) delete flat[key as keyof Flat];
    }
  }

  return flat;
};
